/* Loox publishes a current review sample in storefront HTML. No API key or widget markup is copied. */
(function () {
  'use strict';
  function parseReviews(doc, origin) {
    const seen = new Set();
    return Array.from(doc.querySelectorAll('article.loox-review')).map(article => {
      const text = selector => article.querySelector(selector)?.textContent.trim() || '';
      const id = article.dataset.reviewId || '';
      const photo = article.querySelector('.loox-review-image');
      let image;
      try { image = new URL(photo?.getAttribute('src') || '', origin); } catch { return null; }
      const date = Date.parse(article.querySelector('time')?.getAttribute('datetime'));
      const rating = Number(text('.loox-review-rating').split('/')[0]);
      if (!/^[a-zA-Z0-9_-]+$/.test(id) || seen.has(id) || !photo || image.protocol !== 'https:' || image.hostname !== 'images.loox.io' || !Number.isFinite(date) || rating < 1 || rating > 5 || !Number.isInteger(rating)) return null;
      const body = text('.loox-review-body');
      const name = text('.loox-reviewer-name');
      if (!body || !name) return null;
      seen.add(id);
      return {id, image: image.href, body, name, rating, date, verified: !!article.querySelector('.loox-review-verified'), video: /video/i.test(photo.alt)};
    }).filter(Boolean).sort((a, b) => b.date - a.date);
  }
  function reviewURL(id, current) {
    const url = new URL(current);
    url.searchParams.set('qv', id);
    url.hash = '';
    return url.href;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {parseReviews, reviewURL};
  if (typeof document === 'undefined') return;
  window.HJReviewData = {parseReviews, reviewURL};
  function init(section) {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    section.addEventListener('click', event => {
      const link = event.target.closest('a[data-loox-review-id]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      if (typeof window.LOOX?.openQV === 'function') {
        event.preventDefault();
        window.LOOX.openQV(link.dataset.looxReviewId);
      }
    });
    async function load() {
      const status = section.querySelector('[data-review-status]');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        const source = new URL(section.dataset.source, location.origin);
        if (source.origin !== location.origin) throw new Error('Invalid review source');
        const response = await fetch(source.href, {signal: controller.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('Review source unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const reviews = parseReviews(doc, location.origin).slice(0, 3);
        if (!reviews.length) throw new Error('No media reviews');
        const cards = section.querySelector('[data-review-cards]');
        const select = review => {
          const photo = section.querySelector('[data-review-photo]');
          photo.src = review.image;
          photo.alt = `Customer ${review.video ? 'video' : 'photo'} from ${review.name}`;
          const link = section.querySelector('[data-review-media]');
          link.href = reviewURL(review.id, location.href);
          link.dataset.looxReviewId = review.id;
          link.setAttribute('aria-label', `${review.video ? 'Play video and read' : 'Open photo and read'} ${review.name}’s review`);
          section.querySelector('[data-review-play]').hidden = !review.video;
          const caption = section.querySelector('[data-review-caption]');
          const customer = document.createElement('strong'); customer.className = 'hj-home-caption-name'; customer.textContent = review.name;
          const moment = document.createElement('span'); moment.textContent = '’s happy moment';
          caption.replaceChildren(customer, moment);
        };
        reviews.slice(1).forEach(review => {
          const card = document.createElement('a');
          card.href = reviewURL(review.id, location.href);
          card.dataset.looxReviewId = review.id;
          card.className = 'hj-home-review-card';
          const thumbnail = document.createElement('img');
          thumbnail.src = review.image; thumbnail.alt = ''; thumbnail.loading = 'lazy'; thumbnail.width = 96; thumbnail.height = 112;
          const copy = document.createElement('span'); copy.className = 'hj-home-review-copy';
          const stars = document.createElement('span'); stars.className = 'hj-home-review-stars'; stars.textContent = '★'.repeat(review.rating); stars.setAttribute('aria-label', `${review.rating} out of 5 stars`);
          const quote = document.createElement('span'); quote.className = 'hj-home-review-quote'; quote.textContent = review.body;
          const byline = document.createElement('span'); byline.className = 'hj-home-review-byline'; byline.textContent = review.name + ' · ';
          const reviewed = document.createElement('time');
          reviewed.dateTime = new Date(review.date).toISOString();
          reviewed.textContent = 'Reviewed ' + new Intl.DateTimeFormat('en-US', {month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC'}).format(review.date);
          byline.append(reviewed);
          copy.append(stars, quote, byline); card.append(thumbnail, copy);
          cards.append(card);
        });
        select(reviews[0]);
        section.querySelector('[data-review-layout]').hidden = false;
        status.hidden = true;
      } catch {
        status.textContent = 'Explore our customers’ photos and stories below.';
      } finally { clearTimeout(timeout); }
    }
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); } }, {rootMargin: '800px'});
      observer.observe(section);
    } else load();
  }
  document.querySelectorAll('[data-hj-reviews]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hj-reviews]').forEach(init));
}());
